
















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import StoreAPI from '@/util/api/StoreAPI'
import Entry from '@/data/entry-model'
import { FETCH_UPDATES } from '@/store/entries/constants'
import EntryRepository from '@/data/entry-repository'

@Component({ name: 'vault-selector-item' })
export default class VaultSelectorItem extends Vue {
    open: boolean = false

    @Prop({ type: String, default: '' })
    searchTerm!: string

    @Prop({ type: Object, default: null })
    vault!: Entry

    @Prop({ type: Boolean, default: false })
    createNew!: boolean

    @Prop({ type: String, default: '' })
    createNewValue!: string

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    @Action(FETCH_UPDATES)
    fetchUpdates!: (force?: boolean) => Promise<Entry>

    get current(): boolean {
        return (this.vault && this.vault.id === this.entry.vault)
            || (!this.vault && !this.entry.vault && !this.createNew)
    }

    get children(): Entry[] {
        return this.vault.children
            .filter(child => child.id !== this.entry.id)
    }

    async createVault(title?: string): Promise<void> {
        if (!title) {
            this.$error({ text: 'You need to specify a vault title' })
            return
        }

        const loading = this.$notice({
            text: `Creating vault <strong>${title}</strong>...`,
            timeout: false
        })

        const entry = await EntryRepository.create('vault')
            .setData({
                title,
                parentId: this.vault && this.vault.id
            })
            .save()

        await this.fetchUpdates()

        loading.close()
        this.$success({ text: `Created vault <strong>${title}</strong>` })

        this.update(entry.id!)
    }

    toggleOpen(): void {
        this.open = !this.open
    }

    update(id: string): void {
        this.$emit('update', id)
    }
}
